import React, { Component } from 'react';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import { Row, Col } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import { Admin as Layout } from '../../../components/layouts';
import { Spinner, DateRange } from '../../../components/common';
import { AdminApi } from '../../../api';
import { calendarRanges } from '../../../utils/helpers/calendar_ranges';
import { humanize } from '../../../utils/helpers/text_formatters';
import { baseApiUrl } from '../../../api/ApiHelpers';
import FormModal from '../../../components/admin/common/Form';
import ShowModal from '../../../components/admin/common/Show';
import ExportCSVButton from '../../../components/common/ExportCSVButton';
import { ButtonShow, ButtonEdit } from '../../../components/common/buttons/actions';
import { ButtonExport } from '../../../components/common/buttons';
import { columnWidth } from '../../../utils/helpers/admin/table_formatters';
import { handleOnFilterChange, handleOnSortChange, handleOnPageChange } from '../../../utils/helpers/admin/query_updating';
import { findComparator } from '../../../utils/helpers/filter_conversions';

class AdminStatementIndex extends Component {
  componentWillMount() {
    this.fetchResource();
  }

  generateFilter(dataField) {
    const attributes = this.props?.resource?.meta?.column_info?.attributes || {};
    const dropDownOptions = this.props?.resource?.meta?.options || {};
    const dropdownColumns = ['status', 'payment_type'];
    const { value, predicate } = this.props?.resource?.meta?.filters?.[dataField] || {};
    let filter = {};
    switch (attributes[dataField]) {
      case 'identifier': {
        filter.type = 'TextFilter';
        filter.condition = 'eq';
        filter.defaultValue = '';
        if (value && predicate) filter.defaultValue = value;
        break;
      }
      case 'inet':
      case 'string': {
        filter.type = dropdownColumns.includes(dataField) ? 'SelectFilter' : 'TextFilter';
        filter.condition = 'like';
        filter.defaultValue = '';
        filter.options = dropDownOptions[dataField] ? dropDownOptions[dataField] : null;
        break;
      }
      case 'decimal':
      case 'integer': {
        filter.type = 'NumberFilter';
        filter.numberComparators = ['=', '>', '<'];
        filter.defaultValue = {};
        if (value && predicate) {
          filter.defaultValue = {
            number: parseInt(value, 10),
            comparator: findComparator(predicate),
          };
        }
        break;
      }
      case 'boolean': {
        filter.type = 'SelectFilter';
        filter.options = {
          true: true,
          false: false,
        };
        break;
      }
      case 'datetime': {
        filter.type = 'DateFilter';
        filter.dateComparators = ['=', '>', '<'];
        filter.defaultValue = {};
        if (value && predicate) {
          filter.defaultValue = {
            date: value,
            comparator: findComparator(predicate),
          };
        }
        break;
      }
      default:
        filter = {};
    }

    return filter;
  }

  formatData(field, column, _row) {
    const attributes = this.props?.resource?.meta?.column_info?.attributes || {};
    switch (attributes[field]) {
      case 'datetime':
        if (column) return moment(column).utc().format('MMMM Do[,] YYYY');
        return column;
      default: {
        switch (field) {
          case 'status':
            switch (column) {
              case 'outstanding':
                return <span style={{ color: '#FFC107' }}>{column}</span>;
              case 'overdue':
                return <span style={{ color: '#DC3545' }}>{column}</span>;
              case 'paid_out':
                return <span style={{ color: '#5CB85C' }}>{column}</span>;
              default:
                return column;
            }
          default:
            return column;
        }
      }
    }
  }

  handleShow(_c, resource) {
    const { resourceName, dispatch } = this.props;
    dispatch(
      show('AdminResourceShow', {
        resource,
        resourceName,
        heading: `${humanize(resourceName)} Details`,
        onEdit: this.handleEdit.bind(this),
      }),
    );
  }

  handleEdit(_c, r) {
    const {
      resourceName,
      dispatch,
      resource: {
        meta: { column_info },
      },
    } = this.props;
    const metaParams = {
      page: this.props?.resource?.meta?.pagination?.page || 1,
      per_page: this.props?.resource?.meta?.pagination?.per_page || 10,
      filters: this.props?.resource?.meta?.filters || {},
      sort: this.props?.resource?.meta?.sort || {},
    };
    dispatch(
      show('AdminResourceModal', {
        attributes: column_info.attributes,
        formFields: column_info.edit_form,
        resourceName,
        resource: r,
        heading: `Editing ${humanize(resourceName)}`,
        formAction: 'Update',
        metaParams,
        onShow: this.handleShow.bind(this),
      }),
    );
  }

  handleDateApply(d) {
    const filters = this.props?.resource?.meta?.filters || {};
    const sort = this.props?.resource?.meta?.sort || {};

    this.fetchResource({
      id: this.props.id,
      filters: { ...filters, start_date: d.startDate.format(), end_date: d.endDate.format() },
      sort,
    });
  }

  fetchResource(params = {}) {
    const { resourceName, dispatch } = this.props;
    dispatch(AdminApi.actions[resourceName](params));
  }

  handleSummary() {
    const { startDate, endDate } = this.props;
    const jwt = localStorage.getItem('jwt');
    const url = `${baseApiUrl}/v1/admin/statements/summary.csv?start_date=${startDate}&end_date=${endDate}`;

    fetch(url, {
      headers: {
        Authorization: `Bearer ${jwt.slice(1, -1)}`,
      },
    }).then(res => {
      if (res.status === 200) {
        res.text().then(csvString => {
          const csvContent = `data:text/csv;charset=utf-8,${csvString}`;
          const encodedUri = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', encodedUri);
          link.setAttribute('download', `Statement Summary - ${moment().format('LLL')}.csv`);
          document.body.appendChild(link);
          link.click();
        });
      } else {
        console.log('Error, failed to connect to server');
      }
    });
  }

  renderActions(c, r) {
    const editForm = this.props?.resource?.meta?.column_info?.edit_form || [];
    const shouldRenderEdit = editForm.length > 0;
    return (
      <ul className="list-inline">
        <li>
          <ButtonShow className="btn-trans" bsStyle="primary" onClick={this.handleShow.bind(this, c, r)} />
        </li>
        {shouldRenderEdit && (
          <li>
            <ButtonEdit className="btn-trans" bsStyle="primary" onClick={this.handleEdit.bind(this, c, r)} />
          </li>
        )}
      </ul>
    );
  }

  render() {
    const { resourceName, resource, isLoading, columnAttributes, fetchParams, startDate, endDate } = this.props;
    const { data, meta } = resource || {};
    const { filters } = meta || {};
    const { pagination, column_info, sort } = meta || {};
    const index = column_info?.index_page || [];
    if (index.length > 1) index.move(index.indexOf('uuid'), 0);

    const CSVButton = () => {
      return <ExportCSVButton resourceName={resourceName} filters={filters} start_date={startDate} end_date={endDate} sort={sort} />;
    };

    const options = {
      exportCSVBtn: CSVButton,
      onFilterChange: handleOnFilterChange.bind(this, fetchParams, this.fetchResource.bind(this)),
      onSortChange: handleOnSortChange.bind(this, fetchParams, this.fetchResource.bind(this)),
      sortName: sort?.field || 'id',
      sortOrder: sort?.order || 'desc',
      defaultSortName: sort?.field || 'id',
      defaultSortOrder: sort?.order || 'desc',
      sizePerPage: pagination?.per_page || 10,
      onPageChange: handleOnPageChange.bind(this, fetchParams, this.fetchResource.bind(this)),
      sizePerPageList: [10, 20, 50, 100],
      pageStartIndex: 1,
      page: pagination?.current_page || 1,
    };
    const fetchInfo = { dataTotalSize: pagination?.total_count || 0 };
    const selectRow = { mode: 'checkbox' };
    const passProps = pick(this.props, ['routeParams', 'location', 'routes']);

    return (
      <Layout {...passProps}>
        <div className="ibox">
          <div className="ibox-title">
            <h5>{humanize(resourceName)}</h5>
          </div>
          <div className={`ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Row>
              <Col md={12}>
                <DateRange
                  key="daterange-ad-cu-dash"
                  defaultChosenLabel="Last Month"
                  opens="right"
                  startDate={this.props.startDate}
                  endDate={this.props.endDate}
                  ranges={calendarRanges}
                  onApply={this.handleDateApply.bind(this)}
                />
              </Col>
            </Row>
            <br />
            <div className="pull-right">
              <ButtonExport onClick={this.handleSummary.bind(this)} bsStyle="info" className="m-l-xs" btnLabel="Export Summary" />
            </div>
            <Spinner />
            <BootstrapTable
              exportCSV
              striped
              ref={`${resourceName}Table`}
              data={data || []}
              remote
              pagination
              fetchInfo={fetchInfo}
              selectRow={selectRow}
              options={options}
            >
              {index.length > 1 ? (
                index.map((field, i) => {
                  const isResourceKey = field === 'uuid';

                  return (
                    <TableHeaderColumn
                      key={`${resourceName}-column-${i}`}
                      isKey={isResourceKey}
                      width={columnWidth(field, columnAttributes)}
                      dataSort={!isResourceKey}
                      dataField={field}
                      filter={isResourceKey ? {} : this.generateFilter(field)}
                      dataFormat={isResourceKey ? this.renderActions.bind(this) : this.formatData.bind(this, field)}
                      tdStyle={{ whiteSpace: 'normal' }}
                      thStyle={{ whiteSpace: 'normal' }}
                    >
                      {isResourceKey ? 'Actions' : field}
                    </TableHeaderColumn>
                  );
                })
              ) : (
                <TableHeaderColumn isKey dataField={resourceName} />
              )}
            </BootstrapTable>
            <FormModal />
            <ShowModal />
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const resourceName = 'statement';
  const resource = state.admin[resourceName];
  const columnAttributes = resource?.data?.meta?.column_info?.attributes || {};
  const startDate = resource?.data?.meta?.filters?.start_date || moment().subtract(1, 'months').startOf('month');
  const endDate = resource?.data?.meta?.filters?.end_date || moment().subtract(1, 'months').endOf('month');
  const fetchParams = {
    page: resource?.data?.meta?.pagination?.page || 1,
    per_page: resource?.data?.meta?.pagination?.per_page || 10,
    filters: resource?.data?.meta?.filters || {},
    sort: resource?.data?.meta?.sort || {},
  };

  return {
    resourceName,
    resource: resource.data,
    isLoading: resource.loading,
    columnAttributes,
    fetchParams,
    startDate,
    endDate,
  };
};

export default connect(mapStateToProps)(AdminStatementIndex);
